import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";
const norm = value => {
  if (value === null || value === undefined) return null;
  const trimmed = String(value).trim().toLowerCase();
  return trimmed || null;
};

/**
 * Returns whether the given resource is in the current user's saved items.
 * Mirrors the detection used by SaveButton so a card's saved-state border
 * stays in sync with its corner save toggle. No API calls — reads from the
 * session's saved items in AuthContext.
 */
export function useIsSaved(resourceType, resourceId, resourceSlug) {
  const {
    isAuthenticated,
    savedItems
  } = useAuth();
  const id = norm(resourceId);
  const slug = norm(resourceSlug);
  return useMemo(() => {
    if (!isAuthenticated || !id && !slug) return false;
    return savedItems.some(item => item.resourceType === resourceType && (id && item.resourceId === id || slug && item.resourceSlug === slug));
  }, [isAuthenticated, savedItems, resourceType, id, slug]);
}
export default useIsSaved;